export default __webpack_public_path__ + "static/media/Arhar.22f5d27a.jpg";